import { render } from "./Select2.vue?vue&type=template&id=c0e7494c&scoped=true"
import script from "./Select2.vue?vue&type=script&lang=js"
export * from "./Select2.vue?vue&type=script&lang=js"

import "./Select2.vue?vue&type=style&index=0&id=c0e7494c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c0e7494c"

export default script